var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"rating-stars",class:{
    [`rating-stars--${_vm.size}`]: true,
  },attrs:{"data-e2e":"ratingStars"}},_vm._l((5),function(index){return _c('i',{key:index,staticClass:"cfa cfa-star",class:{ 'active': index <= _vm.roundedScore }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }